import { render, staticRenderFns } from "./subHeaderBdm.vue?vue&type=template&id=4355905a&scoped=true&"
import script from "./subHeaderBdm.vue?vue&type=script&lang=js&"
export * from "./subHeaderBdm.vue?vue&type=script&lang=js&"
import style0 from "./subHeaderBdm.vue?vue&type=style&index=0&id=4355905a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4355905a",
  null
  
)

export default component.exports